import styled, { css } from 'styled-components';

export const BadgeText = styled.div<{ $statusColor: 'success' | 'error' | 'warn' }>`
  width: 79px;
  height: ${({ theme }) => theme.spacing.x6};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  font-size: ${({ theme }) => theme.fs.xxs};
  ${({ $statusColor }) =>
    $statusColor === 'success'
      ? css`
          background: ${({ theme }) => theme.palette.success10};
          color: ${({ theme }) => theme.palette.success};
        `
      : $statusColor === 'error'
      ? css`
          background: ${({ theme }) => theme.palette.error10};
          color: ${({ theme }) => theme.palette.error};
        `
      : css`
          background: ${({ theme }) => theme.palette.warn10};
          color: ${({ theme }) => theme.palette.warn};
        `};
`;
